<template>
  <div class="bg-gray-400 rounded p-2">
    <div class="bg-gray-800 rounded p-2 text-white text-center">
      <h2>증명서 발급 완료</h2>

      <p class="bg-white rounded-lg">
        증명서 발급이 완료 되었어요! 배출구에서 증명서를 수령해 주세요
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JGIssuanceCompleted',
}
</script>
